import React, { Fragment } from 'react'
import IOSSDK from '../../mdx/sdk/ios.mdx'
import AndroidSDK from '../../mdx/sdk/android.mdx'
import GRID from '../../mdx/sdk/grid.mdx'
import WebSDK from '../../mdx/sdk/web.mdx'
import GuideSDK from '../../mdx/sdk/guide.mdx'
import DataCollectionSDK from '../../mdx/sdk/data-collection.mdx'
import ContentTypeSDK from '../../mdx/sdk/content-types.mdx'
import OverviewSDK from '../../mdx/sdk/overview.mdx'
import DividerLine from '../shared/divider-line'
import DocsPageGlobalStyles from '../../styles/docs-page'
import Anchor from '../anchor'

const DocsSection = ({ children, anchorId, dividerLine = true }) => {
    return (
        <section>
            {dividerLine ? <DividerLine /> : ''}
            <Anchor id={anchorId} />
            {children}
        </section>
    )
}

const OptionalSettings = () => {
    return (
        <Fragment>
            <DocsPageGlobalStyles />
            <div className="docsContainer">
                <OverviewSDK />
                <DocsSection anchorId="content-types">
                    <ContentTypeSDK />
                </DocsSection>
                <DocsSection anchorId="grid">
                    <GRID />
                </DocsSection>
                <DocsSection anchorId="ios">
                    <IOSSDK />
                </DocsSection>
                <DocsSection anchorId="android">
                    <AndroidSDK />
                </DocsSection>
                <DocsSection anchorId="web">
                    <WebSDK />
                </DocsSection>
                <DocsSection anchorId="design-guidelines">
                    <GuideSDK />
                </DocsSection>
                <DocsSection anchorId="data-collection">
                    <DataCollectionSDK />
                </DocsSection>
            </div>
        </Fragment>
    )
}

export default OptionalSettings
